import React from "react"
import { Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import { ProductAttributes } from "@secureo/common/typings/ProductAttributes"

const useStyles = makeStyles()(() => ({
	info: {
		textTransform: "uppercase",
		opacity: 0.75,
		fontSize: 13,
		letterSpacing: 0.5,
		fontWeight: 500,
	},
}))

const TechDetails = ({ attributes }: Props) => {
	const { classes } = useStyles()

	const {
		fireSafetyGrade,
		securityGrade,
		// volumeLiter,
		weightKg,
		// innerDepth,
		// innerHeight,
		// innerWidth,
		outerDepth,
		outerWidth,
		outerHeight,
	} = attributes

	return (
		<Box>
			<Box className={classes.info}>Sicherheitsstufe</Box>
			<Box>
				<strong>{securityGrade}</strong>
			</Box>
			<Box className={classes.info} mt={5}>
				Brandschutz
			</Box>
			<Box>
				<strong>{fireSafetyGrade}</strong>
			</Box>
			<Box className={classes.info} mt={5}>
				Außenmaße
			</Box>
			<Box>
				<strong>
					H{outerHeight.toLocaleString()} x B{outerWidth.toLocaleString()} x T
					{outerDepth.toLocaleString()}
				</strong>
			</Box>
			<Box className={classes.info} mt={5}>
				Gewicht
			</Box>
			<Box>
				<strong>{weightKg} Kg</strong>
			</Box>
		</Box>
	)
}

interface Props {
	attributes: ProductAttributes
}

export default TechDetails
